export default {
  fr: {
    contribute: 'Vous contribuez à',
    fund: 'Vous financez',
    support: 'Soutenir',
    choose: 'Choisir ce projet',
    discover: 'Découvrir',
    remove: 'Retirer de la sélection',
    tooltip:
      "Votre montant de dift n'est pas suffisant pour financer cette association",
  },
  en: {
    contribute: 'You contribute to',
    fund: 'You fund',
    support: 'Support',
    choose: 'Choose this project',
    discover: 'Discover',
    remove: 'Remove from selection',
    tooltip: 'Your dift amount is not sufficient to fund this association',
  },
  'pt-br': {
    contribute: 'Você contribui para',
    fund: 'Você financia',
    support: 'Apoiar',
    choose: 'Escolher este projeto',
    discover: 'Descobrir',
    remove: 'Remover da seleção',
    tooltip:
      'Seu valor de dift não é suficiente para financiar esta associação',
  },
  es: {
    contribute: 'Usted contribuye a',
    fund: 'Usted financia',
    support: 'Apoyar',
    choose: 'Elegir este proyecto',
    discover: 'Descubrir',
    remove: 'Retirar de la selección',
    tooltip: 'Su monto de dift no es suficiente para financiar esta asociación',
  },
  de: {
    contribute: 'Sie tragen bei zu',
    fund: 'Sie finanzieren',
    support: 'Unterstützen',
    choose: 'Dieses Projekt wählen',
    discover: 'Entdecken',
    remove: 'Aus der Auswahl entfernen',
    tooltip:
      'Ihr Dift-Betrag reicht nicht aus, um diese Organisation zu finanzieren',
  },
} as const
